// models/produtos/combos/Apresentacao.js
export class Apresentacao {
    constructor(id = 0, nome = '', descricao = '', valorAdicional = 0, apresentacaoConjuntos = []) {
        this.id = id;
        this.nome = nome;
        this.descricao = descricao;
        this.valorAdicional = valorAdicional;
        this.apresentacaoConjuntos = apresentacaoConjuntos; // Lista de ConjuntoItem
    }
}